import { PropsWithChildren } from "react";
import { PostHogProvider } from "posthog-react-native";
import { posthog } from "@/shared/lib/posthog";

export function PostHogWrapper({ children }: PropsWithChildren) {
  if (!posthog) return <>{children}</>;
  return (
    <PostHogProvider
      client={posthog}
      autocapture={{
        captureScreens: false,
        captureTouches: true,
        propsToCapture: ["testID"],
      }}
    >
      {children}
    </PostHogProvider>
  );
}
